<template>
  <v-dialog :value="open" persistent scrollable :width="960">
    <v-card>
      <v-card-title :style="{ alignItems: 'flex-start' }">
        <div>
          <div class="title mb-2">Topic</div>
          <div class="headline">{{ topic }}</div>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="handleCloseButtonClick">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :pagination.sync="localPagination"
          :total-items="localPagination.totalItems"
          hide-actions
        >
          <template #items="{ item }">
            <td>
              <v-btn
                outline
                icon
                color="primary"
                @click="
                  () => {
                    goToLivechat(item, item.app)
                  }
                "
              >
                <v-icon>forum</v-icon>
              </v-btn>
            </td>
            <td>{{ item.id }}</td>
            <td>
              <v-layout align-center :style="{ margin: '-4px' }">
                <v-flex class="pa-1">
                  <v-avatar :size="32">
                    <template v-if="item.profile_pic">
                      <img :src="item.profile_pic" alt="Avatar" :style="{ objectFit: 'cover' }" />
                    </template>
                  </v-avatar>
                </v-flex>
                <v-flex class="pa-1">
                  {{ `${item.first_name} ${item.last_name}` }}
                </v-flex>
              </v-layout>
            </td>
            <td>{{ item.subject }}</td>
            <td>{{ item.pageid }}</td>
            <td>{{ item.status }}</td>
            <td>
              <template v-if="item.channel == 'facebook'">
                <em class="fas fa-brands fa-facebook" />
              </template>
              <template v-else-if="item.channel == 'x'">
                <em class="fas fa-brands fa-x" />
              </template>
              <template v-else-if="item.channel == 'pantip'">
                <em class="fas fa-brands fa-pantip" />
              </template>
              <template v-else><em style="color: grey" class="fas fa-envelope" /></template>
            </td>
            <td>{{ item.period | DateFormat('DD/MM/YYYY HH:mm') }}</td>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-pagination
          :key="timestamp"
          v-model="localPagination.page"
          :length="totalPages"
          @input="handlePaginationInput"
        ></v-pagination>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    topic: {
      type: String,
      default: ''
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localPagination: {
        page: 1,
        rowsPerPage: 10,
        ...this.pagination
      },
      timestamp: 0,
      headers: [
        { text: '', sortable: false },
        { text: 'Ticket no.', value: 'id', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Subject', value: 'subject', sortable: false },
        { text: 'Page', value: 'page', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Channel', value: 'channel', sortable: false },
        { text: 'Period', value: 'period', sortable: false }
      ],
      items: [],
      filter: {
        subject: ''
      },
      loading: true
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    totalPages() {
      const { totalItems = 0, rowsPerPage } = this.localPagination
      return Math.ceil(totalItems / rowsPerPage)
    }
  },
  watch: {
    open(newVal) {
      if (!newVal) return
      this.handleInit()
    },
    pagination(value) {
      this.localPagination = {
        page: 1,
        rowsPerPage: 10,
        ...value
      }
      this.handleInit()
    }
  },
  mounted() {
    this.handleInit()
  },
  methods: {
    handleInit() {
      this.timestamp = Date.now()
      this.loading = true
      this.filter.wrap_up_level_three = this.topic
      this.filter.channel = this.filters.channel
      this.filter.starttime = this.filters.startTime
      this.filter.endtime = this.filters.endTime
      if (this.filter.wrap_up_level_three) {
        this.getTickets(this.filter).then((response) => {
          this.items = response.data
          this.localPagination.totalItems =
            typeof response.total == 'string' ? parseInt(response.total) : response.total
        })
      }
      this.loading = false
    },
    goToLivechat: function (user, app) {
      const routeData = this.$router.resolve({
        name: 'livechat',
        path: `/${this.currentLang}/livechat`,
        query: {
          userid: user.userid,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app
        }
      })
      window.open(routeData.href, '_blank')
    },
    chat(item) {
      this.$emit('chat', { ...item })
    },
    getChannelIconUrl(channel) {
      switch (channel) {
        case 'facebook':
          return '/static/img/assets/logo/icon-facebook-color.png'

        case 'line':
          return '/static/img/assets/logo/icon-line-color.png'

        default:
          return ''
      }
    },
    handleCloseButtonClick() {
      this.$emit('update:open', false)
    },
    handlePaginationInput() {
      this.$emit('update:pagination', { ...this.localPagination })
    },
    getTickets(filter = [], allpage = false, options = null) {
      let data = {
        pageid: this.selectedBot.pageid,
        role: this.$store.state.privilege && this.$store.state.privilege.role,
        ...filter
      }
      if (!allpage) {
        data = {
          ...data,
          limit: this.localPagination.rowsPerPage,
          offset: (this.localPagination.page - 1) * this.localPagination.rowsPerPage
        }
      }
      if (options) {
        data = { ...data, ...options }
      }

      return new Promise((resolve, reject) => {
        api.getTickets(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Overview/QuestionDialog.vue